import { progressiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const Discover: Site = {
  id: 'discover',
  analyticsName: 'discover',
  selector: progressiveVanillaSelector,
  logo: '',
  label: 'Discover',
  platform: '',
};
